import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

interface Props extends RouteProps {
  component: any;
  accessCondition: boolean;
  redirectRoute: string;
  push?: boolean;
}

export const ProtectedRoute: React.FC<Props> = ({
  component: Component,
  accessCondition,
  redirectRoute,
  push,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        accessCondition ?
          <Component {...props} />
          :
          <Redirect push={push} to={redirectRoute} />

      }
    />
  );
};
